module.exports = __webpack_public_path__ + "img/play-store.1b321b68.png";